import { Form, Formik, FormikProps } from 'formik';

import { Button } from '../../components';
import { InputField } from '../../fields';
import { PasswordEditFormValues } from '../../models/User';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'antd';
import { makePasswordEditSchema } from './schema';

interface Props {
  onSubmit: (values: PasswordEditFormValues) => void;
}

function PasswordEditForm({ onSubmit }: Props) {
  const { t } = useTranslation();
  const schema = makePasswordEditSchema(t);

  function handleOnSubmit(values: PasswordEditFormValues) {
    onSubmit && onSubmit(values);
  }

  function renderForm(formikBag: FormikProps<PasswordEditFormValues>) {
    return (
      <div className="password-edit-form">
        <Form>
          <InputField
            name="password"
            type="password"
            size="large"
            label={t('passwordEdit.password.label')}
            placeholder={t('passwordEdit.password.placeholder')}
          />
          <InputField
            name="passwordAgain"
            type="password"
            size="large"
            label={t('passwordEdit.passwordAgain.label')}
            placeholder={t('passwordEdit.passwordAgain.placeholder')}
          />
          <Row justify="center" style={{ marginTop: '30px' }}>
            <Col>
              <Button disabled={formikBag.isSubmitting} htmlType="submit" type="primary">
                {t('passwordEdit.submit')}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  return (
    <Formik<PasswordEditFormValues>
      initialValues={{ oldPassword: '', password: '', passwordAgain: '' }}
      onSubmit={handleOnSubmit}
      validationSchema={schema}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {renderForm}
    </Formik>
  );
}

export default PasswordEditForm;
